module.exports = __webpack_public_path__ + "img/PC_CH.ba0cb64d.png";